import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { App } from 'antd';

/** Video nền trong public/assets/ */
const BG_VIDEO_PC = '/assets/bg-pc.mp4';
const BG_VIDEO_MB = '/assets/bg-mb.mp4';

const WC2026_LANDING_URL = 'https://ok9-dudoan-wc2026.pages.dev/';
/** Mở link WC sau 00:00:00 ngày 01/06/2026 (giờ Việt Nam, UTC+7) */
const WC2026_EVENT_START_MS = new Date('2026-06-01T00:00:00+07:00').getTime();
const HOME_BG_URL = '/assets/images/home/home_bg.png';
const TRO_TAI_DUDOAN_PC = '/assets/images/trotaidudoan.gif';
const TRO_TAI_DUDOAN_MB = '/assets/images/trotaidudoan-mb.gif';
/** Kéo khối main/CTA lên (px) — chồng lên vùng dưới banner GIF */
const TRO_TAI_PULL_UP_PC = 112;
const TRO_TAI_PULL_UP_MB = 72;

const IMG = {
  tySo: '/assets/images/home/dudoantyso.png',
  wc: '/assets/images/home/dudoanwc2026.png',
  tuanloc: '/assets/images/home/tuanloc.gif',
  bao: '/assets/images/home/bao.gif',
  chim: '/assets/images/home/chim.gif'
};

const MASCOTS = [
  { src: IMG.tuanloc, alt: 'Tuần lộc OK9' },
  { src: IMG.bao, alt: 'Báo OK9' },
  { src: IMG.chim, alt: 'Chim OK9' }
];

const MASCOT_IMG_CLASS =
  'h-[220px] w-[220px] md:h-[280px] md:w-[280px] md:h-[320px] md:w-[320px] xl:h-[400px] xl:w-[400px] shrink-0 object-contain object-bottom';

const mascotWrapClass = (index) =>
  [
    'flex shrink-0 justify-center items-end pointer-events-none',
    index === 0 && '-mr-[120px] md:-mr-[200px]',
    index === 1 && 'relative z-[1]',
    index === 2 && '-ml-[120px] md:-ml-[200px]'
  ]
    .filter(Boolean)
    .join(' ');

const HomePage = () => {
  const { search } = useLocation();
  const predictionTo = `/prediction${search}`;
  const { notification } = App.useApp();
  const wcEventStarted = Date.now() >= WC2026_EVENT_START_MS;
  // const wcLandingHref = wcEventStarted ? `${WC2026_LANDING_URL}${search}` : '';
  const wcLandingHref = 'https://ok986.vip/vit/app/prediction';

  const handleWcClick = (e) => {
    if (!wcEventStarted) {
      e.preventDefault();
      notification.warning({
        message: 'Thông báo',
        description: 'Chưa đến thời gian dự đoán.'
      });
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col bg-[#061018] text-white overflow-x-hidden">
      <div
        className="pointer-events-none fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
        aria-hidden
        style={{ backgroundImage: `url(${HOME_BG_URL})` }}
      />
      {/* Background Video PC */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="hidden md:block fixed top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={BG_VIDEO_PC} type="video/mp4" />
      </video>

      {/* Background Video Mobile */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="block md:hidden fixed top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={BG_VIDEO_MB} type="video/mp4" />
      </video>

      <header className="relative z-10 flex flex-col items-center pt-6 md:pt-8 pb-0 px-4">
        <img
          src="/assets/images/home/home_logo.png"
          alt="OK9 — Thể thao xanh chín"
          className="h-[94px] sm:h-[110px] lg:h-[134px] w-auto max-w-full object-contain drop-shadow-lg"
        />
        <img
          src={TRO_TAI_DUDOAN_PC}
          alt="Trổ tài dự đoán"
          className="hidden md:block mt-1 w-full h-auto md:-mt-[80px] lg:-mt-[100px] xl:-mt-[140px] max-w-[min(100%,1500px)] object-contain object-center select-none"
          style={{ marginBottom: -TRO_TAI_PULL_UP_PC }}
          draggable={false}
        />
        <img
          src={TRO_TAI_DUDOAN_MB}
          alt="Trổ tài dự đoán"
          className="md:hidden -mt-[100px] h-auto w-full max-w-[min(100%,420px)] object-contain object-center mx-auto select-none"
          style={{ marginBottom: -TRO_TAI_PULL_UP_MB }}
          draggable={false}
        />
      </header>

      <main className="relative z-10 flex-1 flex flex-col items-center w-full px-3 sm:px-4 pb-4 md:pb-10 -mt-[400px] sm:-mt-[500px] md:-mt-[100px] lg:-mt-[200px] xl:-mt-[400px]">
        {/*
          Mobile: hàng 1 — 2 CTA | hàng 2 — 3 mascot (full width)
          Desktop: 1 hàng — CTA trái | mascot giữa | CTA phải, căn đáy
        */}
        <div className="w-full mt-0 md:-mt-2 max-w-[1350px] mx-auto grid grid-cols-2 md:grid-cols-3 grid-rows-[auto_auto] md:grid-rows-1 gap-x-3 gap-y-5 md:gap-x-4 lg:gap-x-10 md:gap-y-0 items-end">
          <Link
            to={predictionTo}
            className="col-start-1 row-start-1 justify-self-start w-full max-w-[200px] sm:max-w-[240px] md:max-w-[min(100%,280px)] lg:max-w-[300px] xl:max-w-[320px] outline-none rounded-2xl focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-transparent transition-transform active:scale-[0.98]"
          >
            <img
              src={IMG.tySo}
              alt="Dự đoán tỷ số"
              className="w-full h-auto object-contain object-bottom drop-shadow-[0_12px_28px_rgba(0,0,0,0.45)]"
              draggable={false}
            />
          </Link>

          <a
            href={wcLandingHref}
            target={wcEventStarted ? '_blank' : undefined}
            rel={wcEventStarted ? 'noopener noreferrer' : undefined}
            // onClick={handleWcClick}
            className="col-start-2 row-start-1 justify-self-end md:col-start-3 w-full max-w-[200px] sm:max-w-[240px] md:max-w-[min(100%,280px)] lg:max-w-[300px] xl:max-w-[320px] outline-none rounded-2xl focus-visible:ring-2 focus-visible:ring-amber-300 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent transition-transform active:scale-[0.98]"
          >
            <img
              src={IMG.wc}
              alt="Dự đoán World Cup 2026"
              className="w-full h-auto object-contain object-bottom drop-shadow-[0_12px_28px_rgba(0,0,0,0.45)]"
              draggable={false}
            />
          </a>

          <div className="col-span-2 row-start-2 -mb-[40%] md:col-span-1 md:row-start-1 md:col-start-2 flex flex-row justify-center items-end gap-1 md:gap-2 lg:gap-3 px-1 w-full max-w-full min-w-0 overflow-x-hidden md:overflow-x-visible justify-self-center">
            {MASCOTS.map(({ src, alt }, index) => (
              <div key={src} className={mascotWrapClass(index)}>
                <img src={src} alt={alt} className={MASCOT_IMG_CLASS} draggable={false} />
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};;

export default HomePage;
